import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { IFieldEditor } from '@/shared/types/fieldEditor';
import { getEnumKeyByValue } from '@/shared/utils/enums';
import { updateMarkdownImageUrls } from '@/shared/utils/fieldEditor';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { AIFieldType } from '@trace-8/trace8-schema';
import { DefaultTheme } from 'styled-components/dist/types';
import { formatAiFieldValueForTemplate, formatFieldValueForTemplate } from '../../../utils';
import { templateStyles } from '../../style';
import { convertMarkdownToReactPDF, getOneColumnSectionFieldsToDisplay } from '../../utils';
import { PDFMagicWandIcon } from '../PDFMagicWandIcon';

interface OneColumnSectionProps {
  fields: IFieldEditor[];
  templateStylingData: ITemplateStylingSettings;
  includeAiSuggested: boolean;
  theme: DefaultTheme;
}

export const OneColumnSection = ({ fields, templateStylingData, includeAiSuggested, theme }: OneColumnSectionProps) => {
  const styles = StyleSheet.create({
    fieldName: {
      fontSize: '12px',
      fontFamily: 'Open Sans',
      color: theme.font.base,
      fontWeight: 700
    },
    fieldValue: {
      fontSize: '9px',
      fontFamily: 'Open Sans',
      color: theme.font.base,
      fontWeight: 600,
      paddingTop: '2px',
      lineHeight: '1.3px'
    }
  });

  return (
    <View break={Boolean(fields.length === 1 && !fields[0].value && fields[0]?.attachments?.length)}>
      {getOneColumnSectionFieldsToDisplay(fields, includeAiSuggested).map((field, index) => (
        <View
          key={field.id}
          style={{
            marginBottom: index === getOneColumnSectionFieldsToDisplay(fields, includeAiSuggested)?.length - 1 ? '0' : '25px'
          }}
        >
          <View>
            {field.value || field.commentary || field?.attachments?.length ? (
              <View>
                <Text style={styles.fieldName}>{field.name}</Text>
                {field.documentFieldType === getEnumKeyByValue(AIFieldType, AIFieldType.LONG_FORM_CONTENT) ? (
                  <View style={styles.fieldValue}>
                    {convertMarkdownToReactPDF(updateMarkdownImageUrls(field.value || '', field.attachments), templateStylingData, 450, theme)}
                  </View>
                ) : (
                  <Text style={styles.fieldValue}>{formatFieldValueForTemplate(field.documentFieldType, field.value, field.commentary)}</Text>
                )}
              </View>
            ) : null}
            {field.value === null && field.commentary === null && field.AI?.answers.length && includeAiSuggested ? (
              <View>
                {fields.length > 1 ? <Text style={styles.fieldName}>* {field.name}</Text> : null}
                {field.documentFieldType === getEnumKeyByValue(AIFieldType, AIFieldType.LONG_FORM_CONTENT) ? (
                  <View style={styles.fieldValue}>{convertMarkdownToReactPDF(field.AI.answers[0] || '', templateStylingData, 450, theme)}</View>
                ) : (
                  <Text style={styles.fieldValue}>{formatAiFieldValueForTemplate(field.documentFieldType, field.AI.answers[0])}</Text>
                )}
              </View>
            ) : null}
          </View>
        </View>
      ))}
      {fields.filter((field) => field.value === null && field.commentary === null && field.AI?.answers.length).length && includeAiSuggested ? (
        <View style={{ ...templateStyles.aiIconWrap, color: theme.font.weak }}>
          <View
            style={{
              borderRight: `1px solid ${theme.border.base}`,
              paddingRight: '3px'
            }}
          >
            <PDFMagicWandIcon fill={theme.font.weak} />
          </View>
          <Text style={{ margin: '2px 0 0 5px' }}>{fields.length > 1 ? '* These fields are AI Suggested' : 'This field is AI Suggested'}</Text>
        </View>
      ) : null}
    </View>
  );
};
